import {Component, EventEmitter, Input, Output} from '@angular/core';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-attach-file',
	templateUrl: './attach-file.component.html',
	styleUrls: ['./attach-file.component.scss']
})
export class AttachFileComponent {

	@Input() attachments: any;
	@Input() canEdit: boolean = true;
	@Input() submitted: boolean = false;
	@Input() allowed_extensions: string[];
	@Input() limit: number = 1;
	@Input() requiredNumber: number = 0;

	@Output() filesChangeEmitter: EventEmitter<File[]> = new EventEmitter<File[]>();
	translateContext = TranslateContext;

	constructor() {
	}

	onFilesChange(files: File[]): void {
		this.filesChangeEmitter.emit(files);
	}

	remove(index: number): void {
		if (index >= 0) {
			this.attachments.splice(index, 1);
		}
	}
}
